module.exports = __webpack_public_path__ + "static/media/background.26a0413f.png";